import React from 'react';

const IconMinus = props => (
  <svg viewBox="0 0 12.5 1.5" {...props}>
    <title>Minus</title>
    <path d="M11.75 1.5h-11A.76.76 0 0 1 0 .75.76.76 0 0 1 .75 0h11a.76.76 0 0 1 .75.75.76.76 0 0 1-.75.75z" />
  </svg>
);

export default IconMinus;
